<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th class="tw-w-4/12">ชื่อฟอร์ม</th>
                        <th class="tw-w-3/12">กล่องข้อความ</th>
                        <th class="tw-w-4/12">ข้อความแจ้งผู้กรอกฟอร์ม</th>
                        <th class="text-right">ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData.data
                                ? tableData.data.length === 0
                                : tableData.data
                        "
                    >
                        <td class="text-center" colspan="4">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tableData.data" :key="index">
                        <td>
                            {{ item.title }}
                        </td>
                        <td>
                            <div id="form-section">
                                <span
                                    class="tag-style"
                                    v-for="(itemInput,
                                    indputIndex) in item.bodies"
                                    :key="`input-${indputIndex}`"
                                >
                                    {{ itemInput.input }}
                                </span>
                            </div>
                        </td>
                        <td>
                            {{ item.message_text }}
                        </td>
                        <td class="text-right">
                            <a
                                :href="
                                    `/backend/s/${shop}/report-forms?form_id=${item.id}`
                                "
                            >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    title="Edit"
                                >
                                    <i class="fa fa-file-text-o"> รายงาน</i>
                                </button>
                            </a>
                            <a
                                :href="
                                    `/backend/s/${shop}/forms/${item.id}/edit/`
                                "
                            >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-warning"
                                    title="Edit"
                                >
                                    <i class="fa fa-edit"> แก้ไข</i>
                                </button>
                            </a>
                            <button
                                @click="confirmDelete(item.id)"
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert"
                                title="Delete"
                            >
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
            <paginate
                :data="tableData"
                :page="page"
                @onPage="onPage($event)"
                v-show="tableData.total > 0"
            ></paginate>
        </div>
    </div>
</template>
<script type="application/javascript">
import paginate from "../../helper/Paginate.vue";
export default {
    props: ["shop", "form_data"],
    components: {
        paginate
    },
    data() {
        return {
            page: 1,
            loading: false,
            tableData: {}
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        onPage(page) {
            this.page = page;
            this.getData();
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        async getData(data = "") {
            this.loading = await true;
            if (data) {
                this.tableData.data = await data;
            } else {
                this.tableData.data = await this.form_data;
            }
            this.loading = await false;
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบฟอร์มนี้ใช่หรือไม่?",
                text: "เมื่อกดยืนยัน ฟอร์มจะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteForm(id);
                }
            });
        },
        async deleteForm(id) {
            this.loading = true;
            await axios
                .delete(`/backend/s/${this.shop}/forms/${id}`)
                .then(res => {
                    this.getData(res.data.form_data);
                    this.loading = false;
                })
                .catch(err => {})
                .then(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 120px;
    // max-width: 200px;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
#form-section {
    width: 300px;
    display: flex;
    flex-wrap: wrap;
    .tag-style {
        margin: 2px;
        background: #fde273;
        color: #000;
        padding: 4px 8px;
        border-radius: 5px;
    }
}
</style>
